


















































import {Vue, Component, Ref, Prop, PropSync} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import {SelectWings} from "wings-ui-components";
import { CollapseTransition } from "vue2-transitions";
import {AddressBookItem} from "@/store/addressbooks/types";
import {notifySuccess, notifyError} from "@/utils/notify-helper";
import { getTranslatedParams } from '@/utils/notify-utils';
import { ActionLog } from '@/store/auth/types';

@Component({components: {CollapseTransition,SelectWings}})
export default class ImportContacts extends Vue {
  @Ref('validator') validator: any;
  @PropSync('show') is_show!: boolean;
  @PropSync('group_id') groupId!: number;
  @PropSync('contact_ids') contactIds: any;
  @Getter("addressBooks") addressBooks: any;
  @Getter("addressBookItem") addressBookItem: any;
  @Action("getAddressBooks") actionGetItems: any;
  @Action("copyAddressBookContacts") actionCopyAddressBookContacts: any;
  @Action("moveAddressBookContacts") actionMoveAddressBookContacts: any;
  @Action("deleteAddressBookContact") actionDelete: any;
  @Action("actionLog") actionLog: any;

  logObject: ActionLog = {}

  private action = 'copy'
  private toGroup = null

  get toAddressBooksList() {
    return this.addressBooks.filter((item: AddressBookItem) => { return item.id != this.groupId })
  }

  get toAddressBook() {
    return this.addressBooks.find((item: AddressBookItem) => { return item.id == this.toGroup })
  }

  created() {
    try {
      this.actionGetItems()
    } catch(error) {
      notifyError(error)
    }
  }

  async onClick() {
    try {
      const formData = {
        fromGroupId: this.groupId,
        toGroupId: this.toGroup,
        contactIds: this.contactIds,
      }

      let res = null
      let message = ''
      if (this.action == 'copy') {
        this.logObject = {
          actionPage: this.$route.meta.msgKey,
          action: "Contacts copying",
          actionStatus: 'success',
          objectType: "Contact",
          addititionalInfo: getTranslatedParams({
            contactsCopied: this.contactIds.length,
            fromGroupId: this.addressBookItem?.name,
            toGroupId: this.toAddressBook?.name
          })
        }

        res = await this.actionCopyAddressBookContacts(formData)
        message = this.$t('contacts.contacts_copied') + ' ' + res.data.contactCount
      }
      if (this.action == 'move') {
        this.logObject = {
          actionPage: this.$route.meta.msgKey,
          action: "Contacts moving",
          actionStatus: 'success',
          objectType: "Contact",
          addititionalInfo: getTranslatedParams({
            contactsMoved: this.contactIds.length,
            fromGroupId: this.addressBookItem?.name,
            toGroupId: this.toAddressBook?.name
          })
        }

        res = await this.actionMoveAddressBookContacts(formData)
        message = this.$t('contacts.contacts_moved') + ' ' + res.data.contactCount
        this.$emit('refresh')
      }
      if (this.action == 'delete') {
        this.logObject = {
          actionPage: this.$route.meta.msgKey,
          action: "Removal",
          actionStatus: 'success',
          objectType: "Contact",
          addititionalInfo: getTranslatedParams({number: this.contactIds.length, groupId: this.addressBookItem?.name})
        }

        res = await this.actionDelete({contactIds: this.contactIds})
        message = this.$t('contacts.contacts_deleted').toString()
        this.$emit('refresh')
      }
      await this.actionLog(this.logObject)
      if (res.data?.mSISDNDuplicates?.length > 0) message += '<br>' + this.$t('contacts.mSISDNDuplicates') + ': ' + res.data.mSISDNDuplicates.join(', ')
      if (res.data?.emailDuplicates?.length > 0) message += '<br>' + this.$t('contacts.emailDuplicates') + ': ' + res.data.emailDuplicates.join(', ')
      if (res.data?.additionalDulicates?.length > 0) message += '<br>' + this.$t('contacts.additionalDulicates') + ': ' + res.data.additionalDulicates.join(', ')
      notifySuccess(message);

    } catch(error) {
      notifyError(error)
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
    }
  }

}
